import { createGenericStore } from '@/stores/utils/genericStore.js' // Assumes genericStore.js is in your main app's 'resources/js/utils/'
import axios from 'axios'

// 1. Define your custom options
const TasksStoreOptions = {
  state: () => ({
    updatingDeadlineTaskIds: [],
    updatingPriorityTaskIds: [],
    updatingAssigneeTaskIds: [],
    updatingStartAtTaskIds: [],
    updatingStatusTaskIds: [],
  }),

  // Custom getters
  getters: {
    isUpdatingDeadline(state) {
      return (taskId) => state.updatingDeadlineTaskIds.includes(taskId)
    },
    isUpdatingPriority(state) {
      return (taskId) => state.updatingPriorityTaskIds.includes(taskId)
    },
    isUpdatingAssignee(state) {
      return (taskId) => state.updatingAssigneeTaskIds.includes(taskId)
    },
    isUpdatingStartAt(state) {
      return (taskId) => state.updatingStartAtTaskIds.includes(taskId)
    },
    isUpdatingStatus(state) {
      return (taskId) => state.updatingStatusTaskIds.includes(taskId)
    }
  },

  // Custom actions
  actions: {
    async updateDeadline(taskId, deadlineAt) {
      this.error = null
      this.updatingDeadlineTaskIds.push(taskId)

      try {
        const { data } = await axios.patch(`${this.api}/${taskId}/deadline`, {
          deadline_at: deadlineAt,
        })
        this.itemPatchState(data)
        return data
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.updatingDeadlineTaskIds = this.updatingDeadlineTaskIds.filter((id) => id !== taskId)
      }
    },
    async updatePriority(taskId, priority) {
      this.error = null
      this.updatingPriorityTaskIds.push(taskId)

      try {
        const { data } = await axios.patch(`${this.api}/${taskId}/priority`, {
          priority,
        })
        this.itemPatchState(data)
        return data
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.updatingPriorityTaskIds = this.updatingPriorityTaskIds.filter((id) => id !== taskId)
      }
    },
    async updateAssignee(taskId, assignedToUserId) {
      this.error = null
      this.updatingAssigneeTaskIds.push(taskId)

      try {
        const { data } = await axios.patch(`${this.api}/${taskId}/assignee`, {
          assigned_to_user_id: assignedToUserId,
        })
        this.itemPatchState(data)
        return data
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.updatingAssigneeTaskIds = this.updatingAssigneeTaskIds.filter((id) => id !== taskId)
      }
    },
    async updateStartAt(taskId, startAt) {
      this.error = null
      this.updatingStartAtTaskIds.push(taskId)

      try {
        const { data } = await axios.patch(`${this.api}/${taskId}/start-at`, {
          start_at: startAt,
        })
        this.itemPatchState(data)
        return data
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.updatingStartAtTaskIds = this.updatingStartAtTaskIds.filter((id) => id !== taskId)
      }
    },
    async updateStatus(taskId, status) {
      this.error = null
      this.updatingStatusTaskIds.push(taskId)

      try {
        const { data } = await axios.patch(`${this.api}/${taskId}/status`, {
          status,
        })
        this.itemPatchState(data)
        return data
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.updatingStatusTaskIds = this.updatingStatusTaskIds.filter((id) => id !== taskId)
      }
    },
  }
}

// 2. Create the store hook using your generic factory
export const useTasksStore = createGenericStore(
  'Tasks', // Base Store ID
  '/api/v1/tasks', // API Endpoint
  TasksStoreOptions // Pass in your custom logic
)
